import React, { Component } from "react";
import { persistor, store } from "../../store";
import { userLogout } from "../../store/auth/auth.slice";

/**
 * Error boundary that silently recovers from auth-related errors
 * by clearing state and redirecting to home.
 */
class AuthErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("AuthErrorBoundary caught error:", error);
    console.error("Error info:", errorInfo);
    this.recover();
  }

  recover = async () => {
    try {
      // Clear auth state
      store.dispatch(userLogout());

      // Purge persisted storage
      await persistor.purge();

      // Clear any remaining storage
      sessionStorage.removeItem("deeplinkParams");
      localStorage.removeItem("persist:root");
    } catch (e) {
      console.error("Recovery error:", e);
    } finally {
      // Redirect to home
      window.location.href = "/";
    }
  };

  render() {
    if (this.state.hasError) {
      return null;
    }
    return this.props.children;
  }
}

export default AuthErrorBoundary;
